import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { NEW_ORDER_ROUTES } from './routes';
import { NewOrderStackParams } from './types';
import { OrderSummary as OrderSummaryScreen } from '@/screens/new-order/order-summary';
import { PaymentMethodSelectScreen } from '@/screens/payments/payment-method-select-screen';
import { requiresPaymentAtOrderPlacement } from '@/utils/payments';
import { SubstitutionStack } from './substitutions-stack';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';
import { useUserContext } from '@/contexts/user-context';

const Stack = createStackNavigator<NewOrderStackParams>();

export const NewOrderStack: React.FC = () => {
  const screenOptions = useDefaultStackScreenOptions();
  const { selectedRestaurantRelationship } = useUserContext();
  const needsWallet = requiresPaymentAtOrderPlacement(
    selectedRestaurantRelationship,
  );

  return (
    <Stack.Navigator
      initialRouteName={NEW_ORDER_ROUTES.OrderSummary}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={OrderSummaryScreen}
        name={NEW_ORDER_ROUTES.OrderSummary}
      />
      <Stack.Screen
        component={SubstitutionStack}
        name={NEW_ORDER_ROUTES.Substitutions}
      />

      {needsWallet ? (
        <Stack.Screen
          component={PaymentMethodSelectScreen}
          name={NEW_ORDER_ROUTES.PaymentMethod}
        />
      ) : null}
    </Stack.Navigator>
  );
};
